import { styled } from '@mui/material'
import { Box } from '@mui/system'

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: theme.spacing(1),
  color: theme.palette.grey['300'],
  borderRadius: theme.shape.borderRadius,
  height: '100%',
}))

const IconWrapper = styled(Box)(({ theme }) => ({
  color: theme.palette.grey['300'],
}))

export { Container, IconWrapper }
